class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    // const swiperNotice = swiperFun();
    // swiperNotice.init();
      // this.getTotalAmount();

    $('.quantity__input[data-quantity-variant-id=51648177209709]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51648173113709]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51648175341933]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51662298677613]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51697805951341]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51697805984109]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51697805951341]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51701325463917]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51701325496685]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51712189596013]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51712189628781]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51712189661549]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51712189694317]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51754499866989]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51754499899757]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51754500653421]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51824792666477]').prop('readonly', 'readonly').val("1").parent().hide();
    
    $('.quantity__input[data-quantity-variant-id=51900248916333]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51900254880109]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=51900254978413]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=52219288224109]').prop('readonly', 'readonly').val("1").parent().hide();


    // $('.quantity__input[data-quantity-variant-id=52574944559469]').prop('readonly', 'readonly').val("1").parent().hide();
    
    // 隐藏手机壳赠品删除和加减数字框
    $('.cart-remove-button[data-variant-id=52131476898157]').hide();
    $('.quantity__input[data-quantity-variant-id=52131476898157]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=52131476898157]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=52131476898157]').attr('disabled',true);

    // 返校季    
    $('.quantity__input[data-quantity-variant-id=52107067294061]').prop('readonly', 'readonly').val("1").parent().hide();

    //黑五 自动加购 变体 52574944559469 产品14751143199085
    // $('.cart-remove-button[data-variant-id=52574944559469]').hide();
    // $('.quantity__input[data-quantity-variant-id=52574944559469]').prev().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=52574944559469]').next().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=52574944559469]').attr('disabled',true);
    
      var product_id = ['14623915508077','14623914262893','14623915180397','14632488010093','14632488730989','14632488698221','14633050177901','14635029692781','14643346997613','14643347030381','14643347128685','14659802628461'];
      var superGiftSyp_id = ['14627000811885']
      var halloweenId = ['14740087603565']

      var cartContents = fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        var cartArr = [];
        var cartList = data.items;    
        
        // const GIFT_A_ID = 51900248916333;  //  £189	
        // const GIFT_B_ID = 51900254880109;  // £349	
        // const GIFT_C_ID = 51900254978413; // £459	
        // const GIFT_D_ID = 52107067294061; // £299 返校季

        // const Phone_Cases_ID = 52131476898157;
        // const PhoneCasesIdsToCheck = [52060867887469, 52060867920237, 52060867953005,52060867985773,52060868018541,52060868051309,52060868084077,52060868116845,52060868149613,52060868182381,52060868215149,52060868247917];
        // let PhoneCasesTotalQuantity = 0;
        // let hasPhoneCase = false;
        // let phoneCaseQuantity = 0;

        const syncConfigs = [
          {
            mainId: 52131476898157, // Phone_Cases_ID
            variantIds: [52060867887469, 52060867920237, 52060867953005,52060867985773,52060868018541,52060868051309,52060868084077,52060868116845,52060868149613,52060868182381,52060868215149,52060868247917],
            totalQuantity: 0,
            hasItem: false,
            currentQuantity: 0
          }
        ];
       
        // let hasGiftA = false;
        // let hasGiftB = false;
        // let hasGiftC = false;
        // let hasGiftD = false;
        
       
        if (cartList.length > 0) {
          cartList.forEach((item) => {
            cartArr.push(item.product_id);
            // if (item.id === GIFT_A_ID) hasGiftA = true;
            // if (item.id === GIFT_B_ID) hasGiftB = true;
            // if (item.id === GIFT_C_ID) hasGiftC = true;
            // if (item.id === GIFT_D_ID) hasGiftD = true;
            // if (PhoneCasesIdsToCheck.includes(item.id)) {
            //   PhoneCasesTotalQuantity += item.quantity || 0; // 安全处理undefined情况
            // }
            // // 检查购物车是否已包含Phone_Cases_ID
            // if (item.id === Phone_Cases_ID) {
            //   hasPhoneCase = true;
            //   phoneCaseQuantity = item.quantity;
            // }
            syncConfigs.forEach(config => {
              if (config.variantIds.includes(item.id)) {
                config.totalQuantity += item.quantity || 0;
              }
              if (item.id === config.mainId) {
                config.hasItem = true;
                config.currentQuantity = item.quantity;
              }
            });
          });
        }
          // 合并删除操作对象
          const delOperations = {};
          // 合并添加操作数组
          const addItems = [];
        
          // 第一阶段：处理赠品逻辑
          // if (hasGiftA || hasGiftB || hasGiftC || hasGiftD) {
          //   Object.assign(delOperations, {
          //     [GIFT_A_ID]: 0,
          //     [GIFT_B_ID]: 0,
          //     [GIFT_C_ID]: 0,
          //     [GIFT_D_ID]: 0
          //   });
          // } 
        
        // 第二阶段：处理手机壳数量同步
        // if (PhoneCasesTotalQuantity >= 0) {
        //   const currentQuantity = hasPhoneCase ? phoneCaseQuantity : 0;
        //   if (PhoneCasesTotalQuantity > currentQuantity) {
        //     addItems.push({
        //       id: Phone_Cases_ID,
        //       quantity: PhoneCasesTotalQuantity - currentQuantity
        //     });
        //   }
        //   else if (PhoneCasesTotalQuantity !== 0 && PhoneCasesTotalQuantity < currentQuantity) {
        //     delOperations[Phone_Cases_ID] = currentQuantity - PhoneCasesTotalQuantity;
        //   }
        //   else if (PhoneCasesTotalQuantity === 0 && hasPhoneCase) {
        //     delOperations[Phone_Cases_ID] = 0;
        //   }
        // }

        // 处理每种商品的同步逻辑
        syncConfigs.forEach(config => {
          const { mainId, totalQuantity, hasItem, currentQuantity } = config;
          
          if (totalQuantity >= 0) {
            const currentQty = hasItem ? currentQuantity : 0;
            
            if (totalQuantity > currentQty) {
              // 需要添加商品
              addItems.push({
                id: mainId,
                quantity: totalQuantity - currentQty
              });
            } else if (totalQuantity !== 0 && totalQuantity < currentQty) {
              // 需要减少商品数量
              delOperations[mainId] = currentQty - totalQuantity;
            } else if (totalQuantity === 0 && hasItem) {
              // 需要完全移除商品
              delOperations[mainId] = 0;
            }
          }
        });
        // 批量执行操作
        if (Object.keys(delOperations).length > 0) {
          this.clearcart(delOperations);
        }
        if (addItems.length > 0) {
          this.addCart({ items: addItems });
        }

        // 一些购物车的处理
        var finalTotalPrice = data.total_price / 100;
        if(data.item_count > 0){
         $('.cart-count-amount>span:nth-child(1)').text(data.item_count)
        }else{
          $('.cart-count-amount').hide();
        }
        $('.drawer__heading>.total').text(`${data.item_count} items`)
        if(data.original_total_price){
          var originalTotalPrice = data.original_total_price / 100;
          $('s[data-cart-total]').children().text('£'+originalTotalPrice);
        }
        $('.total_value>span').text('£'+finalTotalPrice)
        $('#item_count').text(data.item_count+' items')
        if(finalTotalPrice == 0){
          $('.cart__checkout-button button').attr('disabled','true')
        }
        
        const commonElements = product_id.filter(item => cartArr.some(otherItem => otherItem == item));
        const sypElements = superGiftSyp_id.filter(item => cartArr.some(otherItem => otherItem == item));
        const halloweenElements = halloweenId.filter(item => cartArr.some(otherItem => otherItem == item));
        if(commonElements && commonElements.length > 0){
            $('.auto2-free-gift .product-form__submit').attr('disabled',true);
            $("#auto2-free-gift-tips").show();
            $('#updates_14623915508077').hide();
            $('#updates_14623914262893').hide();
            $('#updates_14623915180397').hide();
            $('#updates_14632488010093').hide();
            $('#updates_14632488730989').hide();
            $('#updates_14632488698221').hide();
            $('#updates_14633050177901').hide();
            $('#updates_14635029692781').hide();
            $('.product div[data-id="14633050177901"] #reset_button,.product div[data-id="14635029692781"] #reset_button').show().attr('disabled', true);
            $('.product div[data-id="14633050177901"] .product-form__off,.product div[data-id="14635029692781"] .product-form__off').show();
            $('.product div[data-id="14633050177901"] .product-form__off,.product div[data-id="14635029692781"] .product-form__off').text('* Already have one in your cart');
              setTimeout(function(){
                 $('#cart_recom1_14633050177901.product-form__submit,#updates_14633050177901.product-form__submit,#cart_recom1_14635029692781.product-form__submit,#updates_14635029692781.product-form__submit,#cart_recom1_14623915508077.product-form__submit,#cart_recom1_14623914262893.product-form__submit,#cart_recom1_14623915180397.product-form__submit,#cart_recom1_14632488010093.product-form__submit,#cart_recom1_14632488730989.product-form__submit,#cart_recom1_14632488698221.product-form__submit,#cart_recom1_14643346997613.product-form__submit,#cart_recom1_14643347030381.product-form__submit,#cart_recom1_14643347128685.product-form__submit').attr('disabled', true);
              },1000);
        }else{
            $('.auto2-free-gift .product-form__submit').attr('disabled',false);
            $("#auto2-free-gift-tips").hide(); 
            $('#updates_14623915508077').show();
            $('#updates_14623914262893').show();
            $('#updates_14623915180397').show();
            $('#updates_14632488010093').show();
            $('#updates_14632488730989').show();
            $('#updates_14632488698221').show();
            $('#updates_14633050177901').show();
            $('#updates_14635029692781').show();
            $('.product div[data-id="14633050177901"] #reset_button,.product div[data-id="14635029692781"] #reset_button').hide().attr('disabled', false);
            $('.product div[data-id="14633050177901"] .product-form__off,.product div[data-id="14635029692781"] .product-form__off').hide();
              setTimeout(function(){
                 $('#cart_recom1_14633050177901.product-form__submit,#updates_14633050177901.product-form__submit,#cart_recom1_14635029692781.product-form__submit,#updates_14635029692781.product-form__submit,#cart_recom1_14623915508077.product-form__submit,#cart_recom1_14623914262893.product-form__submit,#cart_recom1_14623915180397.product-form__submit,#cart_recom1_14632488010093.product-form__submit,#cart_recom1_14632488730989.product-form__submit,#cart_recom1_14632488698221.product-form__submit,#cart_recom1_14643346997613.product-form__submit,#cart_recom1_14643347030381.product-form__submit,#cart_recom1_14643347128685.product-form__submit').attr('disabled', false);
              },1000);
        }
        if(sypElements && sypElements.length > 0){
           $('.auto2-dialog-addcart .product-form__submit').attr('disabled',true);
           $(".auto2-claim-now-tips").show();
        }else{
           $('.auto2-dialog-addcart .product-form__submit').attr('disabled',false);
           $(".auto2-claim-now-tips").hide();
        }
        if(halloweenElements && halloweenElements.length > 0){
           $('#updates_14740087603565').attr('disabled', true);
            $('.product div[data-id="14740087603565"] .product-form__off').text('Free gift successfully added. Limited to one per order.').show();
           setTimeout(function(){
             $('#cart_recom1_14740087603565.product-form__submit').attr('disabled', true);
          },1000);
        }else{
           $('#updates_14740087603565').attr('disabled', false);
            $('.product div[data-id="14740087603565"] .product-form__off').hide();
           setTimeout(function(){
             $('#cart_recom1_14740087603565.product-form__submit').attr('disabled', false);
          },1000);
        }
        return data;
      });
  }
  clearcart(updates) {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
    .then((response) => {
      return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }
  addCart(updates) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
    })
    .then(response => {
        return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }
  getTotalAmount(){
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json()).then(data => {
      const products = data.items.map(item => ({
          productId: item.product_id,
          amountOfMoney: (item.final_line_price) / 100
        })
      );
      var activityCode = $('.calculated-amount').attr('id')
      var data = {
        'site': 'UK_HTVRONT(shopify)',
        'activityCode':activityCode,
        'products': products,
      };
      var RSAdata = {
        version: '1.0.0',
        timestamp: new Date().getTime(),
        project: 'htvRont',
        token: 'f8d045ef1350411894cb9659f6e9dce9',
      };
      var rsaEncryptData = RsaEncrypt(JSON.stringify(RSAdata));
      var jsonData = JSON.stringify(data);
      $.ajax({
        url: 'https://qn.htvront.com/promotion/totalAmount',
        method: 'post',
        data: jsonData,
        contentType: 'application/json',
        headers: {
          Authorization: 'Bearer ' + `${rsaEncryptData}`,
        },
        success: function (res) {
          if (res.code == 200) {
            $('.calculated-amount').show();
            $('.calculated-amount-total-price>b').text(res.data.total);
            var couponAmount;
            if (res.data.nextMoney != -1) {
              if(res.data.couponCode == ''){
                res.data.couponCode = 1;
              }
              if(res.data.nextType == 2){
                couponAmount =  Number(res.data.nextAmount)*100 + '%';
              }else{
                couponAmount = '£' + Math.floor(res.data.nextAmount);
              }
              $(`#calculated-amount-text-${res.data.couponCode}>i`).text(couponAmount);
              $(`#calculated-amount-text-${res.data.couponCode}>b`).text(res.data.nextMoney);
              $(`#calculated-amount-text-${res.data.couponCode}>span`).text(Math.floor(res.data.nextTotalAmount)); 
              $(`#calculated-amount-text-${res.data.couponCode}`).show().siblings().hide();
            } else {
              $('#code-last-text').show().siblings().hide();
            }
            $(`#coupons-bottom-item-${res.data.couponCode}`).show().siblings().hide();
          }
        },
        error: function (xhr, status, error) { },
      });
    });
  };
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Drawer-quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';
    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }
    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if(event.target.name == "note"){
      return
    }
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cartDrawer-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.querySelector('.cart_drawer_totals');
        
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cartDrawer-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        // 总金额变化 进度条变化 start
        /*var totalNumber = Number(parsedState.total_price) / 100;
        var progressBar = document.querySelector('.progress-bar');
        var percentage = (totalNumber / 80) * 100;
        progressBar.style.width = `${percentage}%`;*/
        // 总金额变化 进度条变化 end

      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    //console.log(html,selector)
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
